import React from 'react';
import { SIcon } from '@avalara/skylab-sdk/react';
import { CheckItem } from '../../../shared/accordion-styled-components';
import { GrayBackground } from '../../styled/thank-you';
const IossMiddleContent = () => (React.createElement(GrayBackground, { className: 'text-center pad-all-lg' },
    React.createElement("h3", null, "Information you'll need to set up your IOSS Solution"),
    React.createElement("div", { style: { display: 'inline-block' } },
        React.createElement(CheckItem, { className: 'margin-top-md' },
            React.createElement(SIcon, { name: 'check' }),
            React.createElement("span", null, "Details regarding the activities your business is conducting")),
        React.createElement(CheckItem, null,
            React.createElement(SIcon, { name: 'check' }),
            React.createElement("span", null, "Your VAT numbers (if you already have any)")),
        React.createElement(CheckItem, null,
            React.createElement(SIcon, { name: 'check' }),
            React.createElement("span", null, "Details for the bank account you'll use to pay your VAT")))));
export default IossMiddleContent;
